export default "__VITE_ASSET__CfG5yNx9__"